import URI from 'urijs';
import { QueryParams } from '../constants/QueryParams';

export const getTemplateUrlWithBiParam = (
  url: string,
  httpReferer?: string,
  entryFlow?: string,
): string => {
  const urlWithBi = URI(url)
    .addSearch(QueryParams.HTTP_REFERRER, httpReferer || 'dev-center-templates')
    .addSearch(QueryParams.ENTRY_FLOW, entryFlow);
  return urlWithBi.toString();
};
